import { Dynamicore } from '../dynamicore';

async function getCatalogs(services) {
  const promises = Object
    .entries(services)
    .map(([name, service]) => Dynamicore(service)
      .get()
      .then(({ values = [] }) => [name, values]));
  const data = await Promise.all(promises);

  return Object.fromEntries(data);
};

export default getCatalogs;
